module.exports = __webpack_public_path__ + "img/fuyuanqian.5c31e2c7.jpg";